virtual task {{ driveTaskName }}();
  {{> (partial "uvm-driver/drive-item") context=. bfmTask=bfmTask }}
endtask
